// hooks/useAddBranch.ts
import api from "../../../../../features/auth/axiosConfig";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";

interface AddBranchFormData {
  branchName: string;
  branchopeningdate: string;
  addressLine1: string;
  addressLine2?: string;
  selectedCountry: string;
  selectedState: string;
  selectedCity: string;
  Pincode: string;
}

export const useAddBranch = (resetForm: () => void, fetchBranches: () => void, closeModal: () => void) => {
  const addBranch = async (formData: AddBranchFormData) => {
    if (!formData.branchName?.trim()) {
      notifyError("Please fill in all required fields.");
      return;
    }

    // ✅ Payload mapping (backend safe)
    const payload = {
      name: formData.branchName.trim(),
      openingDate: formData.branchopeningdate,
      addresses: {
        addressLine1: formData.addressLine1.trim(),
        addressLine2: formData.addressLine2?.trim() || null,
        country: formData.selectedCountry,
        state: formData.selectedState,
        city: formData.selectedCity,
        postalCode: formData.Pincode.trim(),
      },
    };

    try {
      await api.post("/app/pos/v2/branch", payload);

      notifySuccess("Branch created successfully");
      resetForm();
      closeModal();
      fetchBranches();
    } catch (err: any) {
      notifyError(err?.response?.data?.message || "An error occurred while creating branch.");
    }
  };

  return { addBranch };
};
